import { css } from "styled-components";

export const FONT_STYLE = {
  REGULAR_12: css`
    /* Font/12 Regular */
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 1.8rem; /* 150% */
    letter-spacing: -0.006rem;
  `,

  REGULAR_14: css`
    /* Font/14 Regular */
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 2rem; /* 142.857% */
    letter-spacing: -0.007rem;
  `,

  BOLD_14: css`
    /* Font/14 Bold */
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 2rem; /* 142.857% */
    letter-spacing: -0.007rem;
  `,

  REGULAR_15: css`
    /* Font/15 Regular */
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 2.2rem; /* 146.667% */
    letter-spacing: -0.015rem;
  `,

  BOLD_15: css`
    /* Font/15 Bold */
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 2.2rem; /* 146.667% */
    letter-spacing: -0.015rem;
  `,

  REGULAR_16: css`
    /* Font/16 Regular */
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2.6rem; /* 162.5% */
    letter-spacing: -0.016rem;
  `,

  BOLD_16: css`
    /* Font/16 Bold */
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.6rem; /* 162.5% */
    letter-spacing: -0.016rem;
  `,

  REGULAR_18: css`
    /* Font/18 Regular */
    font-size: 1.8rem;
    font-weight: 400;
    line-height: 2.8rem; /* 155.556% */
    letter-spacing: -0.018rem;
  `,

  BOLD_18: css`
    /* Font/18 Bold */
    font-size: 1.8rem;
    font-weight: 700;
    line-height: 2.8rem; /* 155.556% */
    letter-spacing: -0.018rem;
  `,

  REGULAR_20: css`
    /* Font/20 Regular */
    font-size: 2rem;
    font-weight: 400;
    line-height: 3rem; /* 150% */
    letter-spacing: -0.02rem;
  `,

  BOLD_20: css`
    /* Font/20 Bold */
    font-size: 2rem;
    font-weight: 700;
    line-height: 3rem; /* 150% */
    letter-spacing: -0.02rem;
  `,

  REGULAR_24: css`
    /* Font/24 Regular */
    font-size: 2.4rem;
    font-weight: 400;
    line-height: 3.6rem; /* 150% */
    letter-spacing: -0.024rem;
  `,

  BOLD_24: css`
    /* Font/24 Bold */
    font-size: 2.4rem;
    font-weight: 700;
    line-height: 3.6rem; /* 150% */
    letter-spacing: -0.024rem;
  `,

  BOLD_28: css`
    /* Font/28 Bold */
    font-size: 2.8rem;
    font-weight: 700;
    line-height: 4.2rem; /* 150% */
    letter-spacing: -0.028rem;
  `,
};
